import { Button, Fieldset, Input, InputUI, Loading, ModalBox, Select, Textarea, Toasts, Upload, } from '@fourthwall/components';
import { useFormik } from '@fourthwall/utils/dist/formik';
import { RemovableUpload } from '@modules/Dashboard/Memberships/components';
import { useCreateImageResources } from '@modules/Dashboard/Memberships/hooks/useCreateImageResources';
import { getRejectionErrors } from '@utils/dropzone';
import React, { useCallback, useState } from 'react';
import { getCategorySelectOptions } from '../Podcast/utils';
import { validationSchema } from './consts';
import * as S from './EditPodcastModal.styled';
export const EditPodcastModal = ({ title, description, authorName, contactEmail, artworkUrl, category, subcategory, loading, onSubmit, onClose, }) => {
    const [newImageResourceId, setNewImageResourceId] = useState(undefined);
    const { createImageResources, isLoading: isLoadingImageResources } = useCreateImageResources();
    const isLoading = loading || isLoadingImageResources;
    const form = useFormik({
        initialValues: {
            title,
            description,
            authorName,
            contactEmail,
            artworkUrl,
            category: subcategory ? `${category} - ${subcategory}` : category,
        },
        onSubmit: (values) => {
            onSubmit(values, newImageResourceId);
        },
        validationSchema,
        validateOnMount: true,
    });
    const handleFileDropRejected = (rejectedFiles) => {
        getRejectionErrors(rejectedFiles, {
            'file-too-large': 'File is larger than 10 megabytes',
        }).forEach((rejection) => {
            Toasts.notify(rejection);
        });
    };
    const addArtwork = useCallback(async (files) => {
        createImageResources({
            files,
            onSuccess: (images) => {
                form.setFieldValue('artworkUrl', images[0].url);
                setNewImageResourceId(images[0].id);
            },
        });
    }, [createImageResources, form]);
    const renderArtwork = () => {
        if (form.values.artworkUrl) {
            return (React.createElement(S.ArtworkContainer, null,
                React.createElement(S.UploadContainer, null,
                    React.createElement(RemovableUpload, { onRemove: () => {
                            form.setFieldValue('artworkUrl', '');
                            setNewImageResourceId(undefined);
                        } },
                        React.createElement(S.Artwork, { src: form.values.artworkUrl }))),
                React.createElement(S.ArtworkInfo, null,
                    React.createElement("span", null, "Cover artwork"),
                    React.createElement(S.ArtworkRecommendation, null, "Recommended 3000x3000px size"))));
        }
        return (React.createElement(S.ArtworkContainer, null,
            React.createElement(S.UploadContainer, null,
                React.createElement(Loading, { isLoading: isLoading },
                    React.createElement(Upload, { accept: {
                            'image/*': [],
                        }, maxSize: 10485760, title: "Drop image or browse", disabled: isLoading, onFileDrop: addArtwork, onFileDropRejected: handleFileDropRejected }))),
            React.createElement(S.ArtworkInfo, null,
                React.createElement("span", null, "Cover artwork"),
                React.createElement(S.ArtworkRecommendation, null, "Recommended 3000x3000px size"))));
    };
    return (React.createElement(ModalBox, { title: "Edit podcast details", buttons: [
            React.createElement(Button, { label: "Cancel", onClick: onClose }),
            React.createElement(Button, { label: "Update", appearance: "primary", loading: isLoading, onClick: form.submitForm }),
        ], onClose: onClose },
        React.createElement(S.Container, null,
            React.createElement(Fieldset, null,
                React.createElement(Fieldset.Row, null,
                    React.createElement(Fieldset.Item, null, renderArtwork())),
                form.errors.artworkUrl && React.createElement(InputUI.Error, null, form.errors.artworkUrl),
                React.createElement(Fieldset.Row, null,
                    React.createElement(Fieldset.Item, null,
                        React.createElement(Input, { label: "Podcast title", disabled: isLoading, ...form.getFieldProps('title') }))),
                React.createElement(Fieldset.Row, null,
                    React.createElement(Fieldset.Item, null,
                        React.createElement(Textarea, { label: "Podcast description", placeholder: "Podcast description", resize: true, disabled: isLoading, ...form.getFieldProps('description') }))),
                React.createElement(Fieldset.Row, null,
                    React.createElement(Fieldset.Item, null,
                        React.createElement(Input, { label: "Author name", suggestion: "This name will appear in the podcast players.", disabled: isLoading, ...form.getFieldProps('authorName') }))),
                React.createElement(Fieldset.Row, null,
                    React.createElement(Fieldset.Item, null,
                        React.createElement(Input, { label: "Contact email", suggestion: "Used to claim your podcast on Spotify. Not publicly shared", disabled: isLoading, ...form.getFieldProps('contactEmail') }))),
                React.createElement(Fieldset.Row, null,
                    React.createElement(Fieldset.Item, null,
                        React.createElement(Select, { label: "Category", disabled: isLoading, options: getCategorySelectOptions(), ...form.getFieldProps('category') })))))));
};
